"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Exported functions
var normalize_1 = require("./normalize");
exports.normalize = normalize_1.normalize;
var denormalize_1 = require("./denormalize");
exports.denormalize = denormalize_1.denormalize;
var entity_cache_1 = require("./entity-cache");
exports.mergeEntityCache = entity_cache_1.mergeEntityCache;
exports.getNormalizedEntity = entity_cache_1.getNormalizedEntity;
exports.updateStale = entity_cache_1.updateStale;
var functions_1 = require("./functions");
exports.defaultGetObjectId = functions_1.defaultGetObjectId;
//# sourceMappingURL=index.js.map